<template>
  <div class="post-component">
    <!-- [ div.container -->
    <div class="container">
      <div class="contents">
        <Header class="header--post">
          <template #title>家紋完成</template>
          <template #menu>
            <router-link to="/edit" class="reedit-img">
              <CancelButton class="header-btn">戻る</CancelButton>
            </router-link>
          </template>
        </Header>

        <div class="contents__body">
          <div class="post">
            <p class="post__lead">家紋画像が完成しました！</p>
            <button type="button" @click="onClickTweetBtn">
              ツイッターでシェアする！
            </button>
            <div class="post-img">
              <img class="post-img__img" :src="postImgSrc" alt="家紋イラスト" />
            </div>
            <p class="post__notice">
              ※PCの場合：画像を右クリックで保存しよう！<br />
              ※スマホの場合：画像を長押しで保存しよう！
            </p>
          </div>
          <div class="btn-post-twitter-container"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  onBeforeMount,
  onMounted,
  onUnmounted,
  reactive,
} from "vue";
import { useRouter } from "vue-router";
import { useGlobalStore } from "@/stores/global";
import CancelButton from "@/components/CancelButton.vue";
import Header from "@/components/Header.vue";
import AppConst from "@/consts/app-const";

export default defineComponent({
  name: "Post",
  components: {
    CancelButton,
    Header,
  },
  setup() {
    const router = useRouter();
    const toSelect = () => router.push({ name: "select" });
    const toEdit = () => router.push({ name: "edit" });

    const { imageEditor } = useGlobalStore();
    const editCompletedImage = imageEditor.editCompletedImage;
    const uploadedImageId = imageEditor.uploadedImageId as string;
    if (!editCompletedImage || !uploadedImageId) {
      toSelect();
      return;
    }
    const postImgSrc = editCompletedImage; // DataURL形式の文字列

    const sns = reactive({
      url: "",
      title: "%23" + AppConst.APP_NAME + "で自分だけの %23家紋 を作ろう！",
      body: "こんな家紋ができました〜↓↓",
      hashtags: AppConst.APP_HASHTAG_EN,
    });

    onBeforeMount(() => {
      setShareUrl(uploadedImageId);
    });

    onMounted(() => {});

    onUnmounted(() => {});

    function setShareUrl(imageId: string) {
      sns.url = process.env.VUE_APP_URL + "result/" + imageId;
    }

    function onClickTweetBtn() {
      let shareURL = "https://twitter.com/intent/tweet";
      shareURL += "?text=" + sns.title + "%0a" + sns.body;
      shareURL += "&hashtags=" + sns.hashtags;
      shareURL += "&url=" + sns.url;

      const option = "status=1,width=818,height=400,top=100,left=100";
      window.open(shareURL, "twitter", option);
    }

    return {
      toEdit,
      postImgSrc,
      onClickTweetBtn,
    };
  },
});
</script>

<style scoped>
@import "/app/assets/css/post.css";
.header-btn {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.post__lead {
  color: #e6b422;
  font-family: "Sawarabi Mincho", sans-serif;
  text-shadow: 1px 1px 2px #666666;
  font-size: 3rem;
}
.post-img__img {
  background: #ffffff;
}
</style>
